import { useEffect, useContext } from "react";
import {
    useNavigate
  } from "react-router-dom";
import axios from "axios";
import Cookies from 'js-cookie';
// import $ from 'jquery';
import UserContext from "../../contexts/UserContext";

const Logout = () => {
    const navigate = useNavigate();
    const {setUser} = useContext(UserContext);
    useEffect(()=>{
    axios.post(`${process.env.REACT_APP_API_URI}/api/users/logout`,null,{ withCredentials: true })
    .then((response) => {
      console.log(response)
      if(response.data.success){
        console.log(response.data.data?.user);
        setUser(null);
        Cookies.remove('accessToken')
        navigate("/login")
      }
    })
    .catch((error) => {
      console.error(error);
      setUser(null)
      navigate("/login")
    })
    },[])
}

export default Logout;